'use client';

import { Button } from '@/components/ui/button';
import { Loader } from 'lucide-react';
import { useTransition, useCallback } from 'react';
import { MdShoppingCart } from 'react-icons/md';
import { toast } from 'sonner';

interface AddToCartButtonProps {
  productId: string;
  incrementProductQuantity: (productId: string) => Promise<void>;
  children: string;
}

const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  productId,
  incrementProductQuantity,
  children,
}) => {
  const [isPending, startTransition] = useTransition();

  const handleClick = useCallback(async () => {
    startTransition(async () => {
      try {
        await incrementProductQuantity(productId);
        toast.success('محصول به سبد خرید اضافه شد', {
          duration: 2000,

          style: {
            color: 'green',
            direction: 'rtl',
          },
        });
      } catch (error) {
        console.error('Error adding product to cart:', error);
        toast.error('خطا در افزودن کالا به سبد خرید. لطفا دوباره تلاش کنید.');
      }
    });
  }, [productId, incrementProductQuantity]);

  return (
    <Button
      disabled={isPending}
      className={`rounded-3xl gap-2 ${isPending ? 'bg-slate-500' : ''}`}
      onClick={handleClick}
    >
      {isPending ? <Loader className="animate-spin" /> : children}
      <MdShoppingCart className="text-xl" />
    </Button>
  );
};

export default AddToCartButton;
